import { DISCOUNT_IDS } from '@constants/apiConstants';
import { Quote } from '@generated/gql/graphql';

const getCbcPrice = (quote: Quote) => {
  const { totalMonthlyCost, discounts } = quote;

  const freeMonthsDiscount = discounts.find(
    (discount) => discount.id === DISCOUNT_IDS.CBC_THREE_MONTHS_FREE_DISCOUNT
  );

  if (freeMonthsDiscount) {
    return '0.00';
  }

  return totalMonthlyCost?.value || '';
};

export { getCbcPrice };
